import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { AuthService } from '../services/auth.service'

/**
 * Custom JWT Interceptor for Angular 19+
 * Uses functional interceptor pattern instead of class-based
 * 
 * Replaces @auth0/angular-jwt's JwtInterceptor which has compatibility issues with Angular 19
 */
export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService)
  const token = authService.getToken()
  const allowedDomains = authService.tokenAllowedDomains

  // Check if the request URL matches allowed domains
  const isAllowedDomain = allowedDomains?.some(domain => 
    req.url.includes(domain)
  ) ?? false

  // Only add token if we have one and the domain is allowed
  if (token && isAllowedDomain) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    })
  }

  return next(req)
}
